/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPointsUpdateReqVo
 */
export interface UserPointsUpdateReqVo {
    /**
     * 积分数量
     * @type {number}
     * @memberof UserPointsUpdateReqVo
     */
    amount: number;
    /**
     * 冻结金额
     * @type {number}
     * @memberof UserPointsUpdateReqVo
     */
    freezeAmount: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof UserPointsUpdateReqVo
     */
    enable: number;
}

/**
 * Check if a given object implements the UserPointsUpdateReqVo interface.
 */
export function instanceOfUserPointsUpdateReqVo(value: object): value is UserPointsUpdateReqVo {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('freezeAmount' in value) || value['freezeAmount'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function UserPointsUpdateReqVoFromJSON(json: any): UserPointsUpdateReqVo {
    return UserPointsUpdateReqVoFromJSONTyped(json, false);
}

export function UserPointsUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPointsUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'freezeAmount': json['freezeAmount'],
        'enable': json['enable'],
    };
}

export function UserPointsUpdateReqVoToJSON(json: any): UserPointsUpdateReqVo {
    return UserPointsUpdateReqVoToJSONTyped(json, false);
}

export function UserPointsUpdateReqVoToJSONTyped(value?: UserPointsUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'freezeAmount': value['freezeAmount'],
        'enable': value['enable'],
    };
}

